require('./helpers/bundle-manifest').register(JSON.parse("{\"fm4F9\":\"index.9345a49a.js\",\"eIXB9\":\"datatron.a889c0b9.png\"}"));